import apiService from './api/apiManager'

class DashBoardDataService {
  async apiDashboardData(dashboardData: {
    from: number
    to: number
    timeFilterIndex: number
  }) {
    return apiService.apiPost('/dashboard/view', dashboardData)
  }

  async apiDashboardDataView(dashboardData: {
    status: string
    from: number | null
    to: number | null
    timeFilterIndex: number
    referenceNumber?: string | null
    applicantName?: string | null
  }) {
    return apiService.apiPost('/dashboard/view/list', dashboardData)
  }
}

export default new DashBoardDataService()
